export const WEBSERVER_API_ROOT: string = "https://www.kafekoigen.no/api/";